"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostboxDocumentsEndpoint = getPostboxDocumentsEndpoint;
exports.getPostboxDocumentDataEndpoint = getPostboxDocumentDataEndpoint;
function getPostboxDocumentsEndpoint() {
    return "/postbox-documents";
}
function getPostboxDocumentDataEndpoint(documentId) {
    return `${getPostboxDocumentsEndpoint()}/${documentId}`;
}
//# sourceMappingURL=postbox-documents.js.map